import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const getHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`,
  },
});

// CRUD for a lead's phone numbers (mirrors leadAddressService.js).
export const getLeadPhoneNumbers = (leadId) =>
  axios.get(`${API_URL}/leads/${leadId}/phone-numbers`, getHeaders());

export const createLeadPhoneNumber = (leadId, data) =>
  axios.post(`${API_URL}/leads/${leadId}/phone-numbers`, data, getHeaders());

export const updateLeadPhoneNumber = (leadId, phoneId, data) =>
  axios.put(`${API_URL}/leads/${leadId}/phone-numbers/${phoneId}`, data, getHeaders());

export const deleteLeadPhoneNumber = (leadId, phoneId) =>
  axios.delete(`${API_URL}/leads/${leadId}/phone-numbers/${phoneId}`, getHeaders());

// Merge a source lead (or placeholder/unknown contact) into a target lead.
// The backend reassigns the source's communications + phone numbers to the
// target and then deletes the source. Returns the updated target lead.
export const mergeLeadInto = (targetLeadId, sourceLeadId, sourceType = 'lead') =>
  axios.post(
    `${API_URL}/leads/${targetLeadId}/merge`,
    { sourceLeadId, sourceType },
    getHeaders()
  );
